import { defineMessages } from 'react-intl';

export const messages: {
	chatPanel: { defaultMessage: string; description: string; id: string };
	helpPanel: { defaultMessage: string; description: string; id: string };
	resizeChatPanel: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	chatPanel: {
		id: 'global-root.chat-panel.label',
		defaultMessage: 'Chat',
		description:
			'Accessible name of the Global Root panel containing the conversation assistant. Announced by screen readers to identify the Chat region.',
	},
	helpPanel: {
		id: 'global-root.help-panel.label',
		defaultMessage: 'Help',
		description:
			'Accessible name of the Global Root panel containing product help. Announced by screen readers to identify the Help region.',
	},
	resizeChatPanel: {
		id: 'global-root.chat-panel.resize-label',
		defaultMessage: 'Resize chat panel',
		description:
			'Accessible label for the draggable splitter that lets keyboard and pointer users resize the Global Root chat panel.',
	},
});
